import { render, staticRenderFns } from "./CheckListItems.vue?vue&type=template&id=be973cb0&scoped=true&lang=pug&"
import script from "./CheckListItems.vue?vue&type=script&lang=js&"
export * from "./CheckListItems.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItems.vue?vue&type=style&index=0&id=be973cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be973cb0",
  null
  
)

export default component.exports